import { render, staticRenderFns } from "./FormSelectRole.vue?vue&type=template&id=4dd3faab"
import script from "./FormSelectRole.vue?vue&type=script&lang=js"
export * from "./FormSelectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports